import { useLocation, Navigate, useParams } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography,Box } from '@mui/material';
import { React, useEffect, useState } from 'react';
// components

import URLS from '../../../services/urls.service';
import Page from '../../../components/Page';
import AppCache from '../../../services/AppCache';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';

import ServiceRequestBDTrackerListingPage from "../../../components/SidebarMenuComponents/ServiceRequestComponent/ServiceRequestBDTrackerListingPage";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ServiceRequestBDTrackerListing() {

    const location = useLocation();
    const trackerData = location.state;

    const query = new URLSearchParams(location.search);

    const trackerId = query.get("trackerId");  // always comes from URL
    const menuUrl = location.state?.menuUrl;   // optional, if you still need raw

    const [isLoading, setIsLoading] = useState(false);

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const [trackerName, setTrackerName] = useState("");
    const [allowAdd, setAllowAdd] = useState("");
    const [allowEdit, setAllowEdit] = useState("");
    const [allowDelete, setAllowDelete] = useState("");

    const [trackerMasterId, setTrackerMasterId] = useState("");
    const [userId, setUserId] = useState([]);
  

  
    useEffect(() => {
        // setIsLoading(true);
        if (trackerId) {
            console.log("Calling API with trackerId:", trackerId);
            URLS.getTrackerName({ Id: Number(trackerId) })
                .then((response) => {
                    const data = response?.data?.[0];
                    setTrackerName(data.TrackerName);
                    setTrackerMasterId(data.Id);
                    setAllowAdd(data.AllowAdd);
                    setAllowEdit(data.AllowEdit);
                    setAllowDelete(data.AllowDelete);
                    setIsLoading(false);
                })
                .catch(error => {
                    // setIsLoading(false);

                    console.log("Error fetching tracker name:", error);
                });
        }
    }, [trackerId]); 

    return (
        <Page title={trackerName || "tiketic"} >
           
            <StickyHeader title={trackerName || "Service Request Incident Tracker  "} />

            <ContentStyle>
                {trackerMasterId ? (
                    <ServiceRequestBDTrackerListingPage trackerData={trackerData} trackerName={trackerName} trackerMasterId={trackerMasterId} allowAdd={allowAdd} allowEdit={allowEdit} allowDelete={allowDelete} trackerId={trackerId} />
                ): null}
            </ContentStyle>
        </Page>
    );
}

